import React, { Component } from "react"
import styled from "styled-components"
import { SECONDARY_TEXT, ACTIVE_TEXT } from "./consts/colors"

const SectionContainerBackground = styled.div`
  display: flex;
  position: absolute;
  z-index: ${props => props.zindex};
  width: 100vw;
  height: ${props => props.height};
  top: ${props => props.positionTB};
  background-image: url(${props => props.BG});
  background-size: cover;
  background-position: center;
`

export default ({ height, positionTB, BG, zindex }) => (
  <SectionContainerBackground
    height={height}
    positionTB={positionTB}
    BG={BG}
    zindex={zindex}
  />
)



// WEBPACK FOOTER //
// ./src/components/SectionContainerBackground.js